export default "__VITE_ASSET__af63ea81__"